import React from 'react'

type Props = {
  name: string
  accountCompletedCaseCount?: number | null
}

export const InterpreterNameWithCaseCount: React.FC<Props> = ({
  name,
  accountCompletedCaseCount,
}) => {
  if (accountCompletedCaseCount == null) {
    return <span>{name}</span>
  }

  const label = accountCompletedCaseCount === 1 ? 'case' : 'cases'

  return (
    <span className='d-flex flex-column align-items-start'>
      <span>{name}</span>
      <span className='text-muted fw-normal' style={{fontSize: '0.875em', lineHeight: 1.2}}>
        {accountCompletedCaseCount} {label}
      </span>
    </span>
  )
}
